module.exports = __webpack_public_path__ + "static/media/5-concealers-value-grayscale.fa4f2599.jpg";